import { Injectable, inject } from '@angular/core';
import { signOut as amplifySignOut } from 'aws-amplify/auth';
import {CookieService} from 'ngx-cookie-service';
import {Router} from '@angular/router';
import {Observable, of} from 'rxjs';
import {NgxSpinnerService} from 'ngx-spinner';
import {environment} from "../../environments/environment";

@Injectable({
	providedIn: 'root'
})
export class AuthService {
	private cookiesService = inject(CookieService);
	private spinner = inject(NgxSpinnerService);
	private router = inject(Router);



	signOut() {
		amplifySignOut()
			.then(() => {
				this.cookiesService.deleteAll('/', '.devmente.com');
				window.location.href = environment.login + '?redirectTo=' + window.location.href.split('#')[0];
			})
			.catch(() => {
				this.spinner.hide();
			});
	}

	public isAuthenticatedGuard(): Observable<boolean> {
		const tokenValue = this.cookiesService.get('access_token');

		return of(!!tokenValue);
	}
}
